import { requests } from ".";
import config from "../config";

export const CompanyService = {
  getById: (companyId: string) => requests().get("/companies/" + companyId),
  exportDetails: async (companyId: string) => {
    const { data } = await requests(config.SAAS).get(
      `/isv-mode/export-sub-accounts-details/${companyId}`
    );
    return data;
  },
};
